import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cuitFormat',
})
export class CuitFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const onlyNumbers = value.replace(/\D/g, '').slice(0, 11);

    const part1 = onlyNumbers.slice(0, 2);
    const part2 = onlyNumbers.slice(2, 10);
    const part3 = onlyNumbers.slice(10, 11);

    let formatted = part1;
    if (part2) formatted += '-' + part2;
    if (part3) formatted += '-' + part3;

    return formatted;
  }
}
